import React from "react";

// Where a banner links to. Links off the site open in a new tab.
const bannerLink = (item) => {
  if (item.url.includes("Hubspotrefer") || item.url.includes("Rugby")) {
    return { href: item.pointer, external: true };
  }
  if (item.pointer.includes("Horse Racing")) {
    return { href: "https://tab.co.za/tabs/horse", external: true };
  }
  if (item.pointer.includes("content-")) {
    return { href: `https://content.4racing.com/${item.pointer.substring(8)}`, external: true };
  }
  return { href: "/pools-and-matches/" + item.pointer, external: false };
};

const Banner = ({ item, imageLoaded, index, imageIndex, confirmLoaded }) => {
  const { href, external } = bannerLink(item);
  const image = (
    <img
      style={imageLoaded && index === imageIndex ? { display: "inline" } : { display: "none" }}
      src={item.url}
      alt={item.PartitionKey}
      onLoad={confirmLoaded}
    />
  );
  if (!external) {
    return <a href={href}>{image}</a>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {image}
    </a>
  );
};

export default Banner;
